<template>
  <div class="app-container">
    <div>
      <el-tabs v-model="activeName" @tab-click="handleClicktab">
        <el-tab-pane label="待确认" name="first">
          <div class="formBox margbot" ref="searchBox" >
            <el-form :inline="true" :model="pageInfo" label-width="100px">
              <div class="formItemBox">
               <el-form-item label="一级货主:" >
            <el-select v-model="pageInfo.primaryCustomerTaxId" clearable size="mini" filterable placeholder="请选择">
              <el-option v-for="(item, index) in customerData" :key="index" :label="item.custerName"
                :value="item.taxpayerNumber">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="二级货主:">
            <el-select v-model="pageInfo.customerTaxId" size="mini" clearable filterable placeholder="请选择">
              <el-option v-for="(item, index) in customerData" :key="index" :label="item.custerName"
                :value="item.taxpayerNumber">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="货物类型:">
            <el-select v-model="pageInfo.productType" size="mini" clearable @change="productTypeChange" filterable
              placeholder="请选择">
              <el-option v-for="(item, index) in productTypeData" :key="index" :label="item.productTypeName"
                :value="item.productType">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="产地:">
            <el-select v-model="pageInfo.steelMillName" size="mini" clearable @change="steelMillNameChange" filterable
              placeholder="请选择">
              <el-option v-for="(item, index) in steelMillNameData" :key="index" :label="item" :value="item">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="规格:" >
            <el-select v-model="pageInfo.specification" size="mini" clearable @change="specificationChange" filterable
              placeholder="请选择">
              <el-option v-for="(item, index) in specificationData" :key="index" :label="item" :value="item">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="材质:">
            <el-select v-model="pageInfo.model" size="mini" @change='modelChange' clearable filterable
              placeholder="请选择">
              <el-option v-for="(item, index) in modelData" :key="index" :label="item" :value="item">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="入库单号:" >
            <el-input placeholder="" maxlength="100" size="mini" v-model.trim="pageInfo.instockNo"></el-input>
          </el-form-item>
          <el-form-item label="车牌号:" >
            <el-input placeholder="" maxlength="100" size="mini" v-model.trim="pageInfo.instockPlateNumber"></el-input>
          </el-form-item>
          <el-form-item label="入库时间:" >
            <div style="display: flex;">
            <el-date-picker v-model="pageInfo.instockDateStart" size="mini" placeholder="选择日期" type="datetime"
              value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>&nbsp;-&nbsp;
            <el-date-picker v-model="pageInfo.instockDateStartEnd" size="mini" placeholder="选择日期"
              value-format="yyyy-MM-dd HH:mm:ss" type="datetime"></el-date-picker>
              </div>
          </el-form-item>
          <el-form-item label="到货方式" >
            <el-select v-model="pageInfo.arrivalMethod" size="mini" placeholder="请选择">
              <el-option label="全部" value=""></el-option>

              <el-option label="汽运" value="汽运"></el-option>
              <el-option label="火运" value="火运"></el-option>
              <el-option label="船运" value="船运"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="仓位:" >
            <el-select filterable @change="changeCangWei(pageInfo.warehouseId)" v-model="pageInfo.warehouseId"
              size="mini" placeholder="请选择仓位名" clearable>
              <el-option v-for="(item, index) in CWData" :key="index" :label="item.warehouseName"
                :value="item.warehouseId"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="区位:" >
            <el-select v-model="pageInfo.locationId" size="mini" placeholder="请选择区位" filterable clearable>
              <el-option v-for="item in QUData" :key="item.locationId" :label="item.locationName"
                :value="item.locationId">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="入库外部单号:"  >
            <el-input class="ipt" v-model="pageInfo.inExternalNo" placeholder="请输入入库外部单号" size="mini"
              maxlength="10"></el-input>
          </el-form-item>
              </div>
              <div>
              <el-form-item>
                <el-button type="primary" size="mini" @click="chaxun" btnCode="00ZP003B001" v-if="btnFlg[0]">查询
                </el-button>
                <el-button type="primary" size="mini" @click="chongzhi" btnCode="00ZP003B002" v-if="btnFlg[1]">重置
                </el-button>
                <el-button type="primary" size="mini" @click="daochu" btnCode="00ZP003B003" v-if="btnFlg[2]">导出
                </el-button>
                <el-button type="primary" size="mini" @click="QRjincang" btnCode="00ZP003B007" v-if="btnFlg[3]">进仓确认
                </el-button>
              </el-form-item>
               <el-form-item>
                总吨数:
                <span style="color: red">{{Number(totalAllWeight)}}</span> &nbsp;吨
             </el-form-item>
              <el-form-item>
                总件数:
                <span style="color: red">{{ totalNumber }}</span> &nbsp;件
               </el-form-item>
              </div>
            </el-form>
          </div>
          <div :style="{height:h}">
            <el-table border center bordersize="mini" :data="tableData" height="100%" style="width:100%" size="mini"
              ref='tableRef' highlight-current-row :header-cell-style="{ background: '#F5F5F5', color: 'black' }"
              @selection-change="selectGoods" @row-click='handleRow'>
                <el-table-column type="selection" width="55" align="center" ></el-table-column>
                <el-table-column type="index" prop="date" width="55" label="序号" align="center"></el-table-column>
                <el-table-column :show-overflow-tooltip="true" prop="instockDate" label="入库时间" align="center"
                  width="190"></el-table-column>
                <el-table-column :show-overflow-tooltip="true" prop="instockUser" label="入库人" align="center"
                  min-width="120"></el-table-column>
                <el-table-column :show-overflow-tooltip="true" prop="instockNo" label="入库单号" align="center"
                  width="210"></el-table-column>
                <el-table-column :show-overflow-tooltip="true" prop="instockPlateNumber" label="车牌号" align="center"
                  width="150"></el-table-column>
                <el-table-column :show-overflow-tooltip="true" prop="primaryCustomerName" label="一级货主" align="center"
                  width="250"></el-table-column>
                <el-table-column :show-overflow-tooltip="true" prop="customerName" label="二级货主" align="center"
                  width="250"></el-table-column>
                <el-table-column :show-overflow-tooltip="true" prop="productTypeName" label="货物类型" align="center"
                min-width="120"></el-table-column>
                <el-table-column :show-overflow-tooltip="true" prop="steelMillName" label="产地" align="center"
                min-width="120"></el-table-column>
                <el-table-column :show-overflow-tooltip="true" prop="specification" label="规格" align="center"
                  min-width="120"></el-table-column>
                <el-table-column :show-overflow-tooltip="true" prop="model" label="材质" align="center"
                  min-width="120"></el-table-column>
                <el-table-column :show-overflow-tooltip="true" prop="number" label="件数" align="center"
                  width="80"></el-table-column>
                <el-table-column :show-overflow-tooltip="true" prop="allWeight" label="总重量（吨）" align="center" min-width="120">
                  <template slot-scope="scope">
                    <div>
                      <span v-if="scope.row.allWeight == undefined || scope.row.allWeight == ''"></span>
                      <span v-else>{{ Number(scope.row.allWeight).toFixed(3) }}</span>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column :show-overflow-tooltip="true" prop="weight" label="理重（吨）" align="center" min-width="120">
                  <template slot-scope="scope">
                    <div>
                      <span v-if="scope.row.weight == undefined || scope.row.weight == ''"></span>
                      <span v-else>{{ Number(scope.row.weight).toFixed(3) }}</span>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column :show-overflow-tooltip="true" prop="weighingWeight" label="过磅净重（吨）" align="center" min-width="120">
                  <template slot-scope="scope">
                    <div>
                      <span v-if="scope.row.weighingWeight == undefined || scope.row.weighingWeight == ''"></span>
                      <span v-else>{{ Number(scope.row.weighingWeight).toFixed(3) }}</span>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column :show-overflow-tooltip="true" prop="factoryWeight" label="出厂过磅净重" align="center" min-width="120">
                  <template slot-scope="scope">
                    <div>
                      <span v-if="scope.row.factoryWeight == undefined || scope.row.factoryWeight == ''"></span>
                      <span v-else>{{ Number(scope.row.factoryWeight).toFixed(3) }}</span>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column :show-overflow-tooltip="true" prop="warehouseName" label="仓位" align="center"
                  width="150"></el-table-column>
                <el-table-column :show-overflow-tooltip="true" prop="locationName" label="区位" align="center"></el-table-column>
                <el-table-column :show-overflow-tooltip="true" prop="arrivalMethod" label="到货方式" align="center" min-width="100">
                  <template scope="scope">
                    {{ scope.row.arrivalMethod == 1 ? '汽运' : scope.row.arrivalMethod == 2 ? '火运' : scope.row.arrivalMethod == 3 ?
                      '船运' : scope.row.arrivalMethod }}
                  </template>

                </el-table-column>
                <el-table-column :show-overflow-tooltip="true" prop="driverName" label="司机" align="center"
                min-width="120"></el-table-column>
                <el-table-column :show-overflow-tooltip="true" prop="telephone" label="司机电话" align="center"
                  width="150"></el-table-column>
                <el-table-column :show-overflow-tooltip="true" prop="idNumber" label="司机身份证号" align="center"
                  width="180"></el-table-column>
                <el-table-column :show-overflow-tooltip="true" prop="sceneUser" label="现场人员" align="center"
                min-width="120"></el-table-column>
                <el-table-column :show-overflow-tooltip="true" prop="ext1" label="备注" align="center"
                  width="150"></el-table-column>
                <el-table-column :show-overflow-tooltip="true" prop="inExternalNo" label="入库外部单号" align="center" width="200">
                </el-table-column>
            </el-table>
          </div>
          <div class="pags">
            <el-pagination background @current-change="handleCurrentChange" :current-page="pageInfo.pageNo"
              :page-size="pageInfo.pageSize" :page-sizes="[10,20,30,40,50]"
              layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChange" :total="total">
            </el-pagination>
          </div>
        </el-tab-pane>
        <el-tab-pane label="已确认" name="second">
          <div class="formBox margbot" ref="searchBoxT">
            <el-form :inline="true" :model="pageInfoT" label-width="100px">
            <div class="formItemBox">
              <el-form-item label="一级货主:" >
            <el-select v-model="pageInfoT.primaryCustomerTaxId" clearable size="mini" filterable placeholder="请选择">
              <el-option v-for="(item, index) in customerData" :key="index" :label="item.custerName"
                :value="item.taxpayerNumber">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="二级货主:" >
            <el-select v-model="pageInfoT.customerTaxId" size="mini" clearable filterable placeholder="请选择">
              <el-option v-for="(item, index) in customerData" :key="index" :label="item.custerName"
                :value="item.taxpayerNumber">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="货物类型:" >
            <el-select v-model="pageInfoT.productType" size="mini" clearable @change="productTypeChange" filterable
              placeholder="请选择">
              <el-option v-for="(item, index) in productTypeData" :key="index" :label="item.productTypeName"
                :value="item.productType">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="产地:" >
            <el-select v-model="pageInfoT.steelMillName" size="mini" clearable @change="steelMillNameChange" filterable
              placeholder="请选择">
              <el-option v-for="(item, index) in steelMillNameData" :key="index" :label="item" :value="item">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="规格:" >
            <el-select v-model="pageInfoT.specification" size="mini" clearable @change="specificationChange" filterable
              placeholder="请选择">
              <el-option v-for="(item, index) in specificationData" :key="index" :label="item" :value="item">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="材质:" >
            <el-select v-model="pageInfoT.model" size="mini" @change='modelChange' clearable filterable
              placeholder="请选择">
              <el-option v-for="(item, index) in modelData" :key="index" :label="item" :value="item">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="入库单号:" >
            <el-input placeholder="" maxlength="100" size="mini" v-model.trim="pageInfoT.instockNo"></el-input>
          </el-form-item>
          <el-form-item label="车牌号:" >
            <el-input placeholder="" maxlength="100" size="mini" v-model.trim="pageInfoT.instockPlateNumber"></el-input>
          </el-form-item>
          <el-form-item label="入库时间:" >
            <div style="display: flex;">
            <el-date-picker v-model="pageInfoT.instockDateStart" size="mini" placeholder="选择日期" type="datetime"
              value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>&nbsp;-&nbsp;
            <el-date-picker v-model="pageInfoT.instockDateStartEnd" size="mini" placeholder="选择日期"
              value-format="yyyy-MM-dd HH:mm:ss" type="datetime"></el-date-picker>
              </div>
          </el-form-item>
          <el-form-item label="到货方式" >
            <el-select v-model="pageInfoT.arrivalMethod" size="mini" placeholder="请选择">
              <el-option label="全部" value=""></el-option>

              <el-option label="汽运" value="汽运"></el-option>
              <el-option label="火运" value="火运"></el-option>
              <el-option label="船运" value="船运"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="仓位:" >
            <el-select filterable @change="changeCangWei(pageInfoT.warehouseId)" v-model="pageInfoT.warehouseId"
              size="mini" placeholder="请选择仓位名" clearable>
              <el-option v-for="(item, index) in CWData" :key="index" :label="item.warehouseName"
                :value="item.warehouseId"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="区位:" >
            <el-select v-model="pageInfoT.locationId" size="mini" placeholder="请选择区位" filterable clearable>
              <el-option v-for="item in QUData" :key="item.locationId" :label="item.locationName"
                :value="item.locationId">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="入库外部单号:"  >
            <el-input class="ipt" v-model="pageInfoT.inExternalNo" placeholder="请输入入库外部单号" size="mini"
              maxlength="10"></el-input>
          </el-form-item>
             </div>
             <div>
              <el-form-item>
                <el-button type="primary" size="mini" @click="chaxunT" btnCode="00ZP003B008" v-if="btnFlg[4]">查询
                </el-button>
                <el-button type="primary" size="mini" @click="chongzhiT" btnCode="00ZP003B009" v-if="btnFlg[5]">重置
                </el-button>
                <el-button type="primary" size="mini" @click="daochuT" btnCode="00ZP003B00A" v-if="btnFlg[6]">导出
                </el-button>
                <el-button type="primary" size="mini" @click="xiugaiT" btnCode="00ZP003B00B" v-if="btnFlg[7]">修改进仓单
                </el-button>
                <el-button type="primary" size="mini" @click="chexiao" btnCode="00ZP003B00D" v-if="btnFlg[8]">撤销
                </el-button>
              </el-form-item>
               <el-form-item>
                总吨数:
                <span style="color: red">{{Number(totalAllWeightB)}}</span> &nbsp;吨
              </el-form-item>
              <el-form-item>
                总件数:
                <span style="color: red">{{ totalNumberB }}</span> &nbsp;件
               </el-form-item>
              </div>
            </el-form>
          </div>
          <div :style="{height:H}">
            <el-table border center bordersize="mini" :data="tableDataT" height="100%" style="width:100%" size="mini"
              ref="QRTable" @selection-change="selectGoods" @row-click='handleRow1'>
              <el-table-column type="selection" align="center" width="40"></el-table-column>
              <el-table-column type="index" align="center" label="序号" width="50"></el-table-column>
              <el-table-column width="80" label="操作" align="center">
                <template v-slot='scope'>
                  <el-button type="text" @click="editRecord(scope.$index,scope.row)">修改记录</el-button>
                </template>
              </el-table-column>
              <el-table-column :show-overflow-tooltip="true" prop="confirmTime" label="确认时间" align="center"
                width="190"></el-table-column>
              <el-table-column :show-overflow-tooltip="true" prop="inWarehouseNo" label="进仓单号" align="center"
                min-width="120"></el-table-column>
              <el-table-column :show-overflow-tooltip="true" prop="confirmName" label="确认人" align="center"
                min-width="120"></el-table-column>
              <el-table-column :show-overflow-tooltip="true" prop="instockDate" label="入库时间" align="center"
                width="190"></el-table-column>
              <el-table-column :show-overflow-tooltip="true" prop="instockUser" label="入库人" align="center"
                min-width="120"></el-table-column>
              <el-table-column :show-overflow-tooltip="true" prop="instockNo" label="入库单号" align="center"
                width="210"></el-table-column>
              <el-table-column :show-overflow-tooltip="true" prop="instockPlateNumber" label="车牌号" align="center"
                width="150"></el-table-column>
              <el-table-column :show-overflow-tooltip="true" prop="primaryCustomerName" label="一级货主" align="center"
                width="250"></el-table-column>
              <el-table-column :show-overflow-tooltip="true" prop="customerName" label="二级货主" align="center"
                width="250"></el-table-column>
              <el-table-column :show-overflow-tooltip="true" prop="productTypeName" label="货物类型" align="center"
              min-width="120"></el-table-column>
              <el-table-column :show-overflow-tooltip="true" prop="steelMillName" label="产地" align="center"
              min-width="120"></el-table-column>
              <el-table-column :show-overflow-tooltip="true" prop="specification" label="规格" align="center"
                min-width="120"></el-table-column>
              <el-table-column :show-overflow-tooltip="true" prop="model" label="材质" align="center"
                min-width="120"></el-table-column>
              <el-table-column :show-overflow-tooltip="true" prop="number" label="件数" align="center"
                width="80"></el-table-column>
              <el-table-column :show-overflow-tooltip="true" prop="allWeight" label="总重量（吨）" align="center" min-width="120">
                <template slot-scope="scope">
                  <div>
                    <span v-if="scope.row.allWeight == undefined || scope.row.allWeight == ''"></span>
                    <span v-else>{{ Number(scope.row.allWeight).toFixed(3) }}</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column :show-overflow-tooltip="true" prop="weight" label="理重（吨）" align="center" min-width="120">
                <template slot-scope="scope">
                  <div>
                    <span v-if="scope.row.weight == undefined || scope.row.weight == ''"></span>
                    <span v-else>{{ Number(scope.row.weight).toFixed(3) }}</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column :show-overflow-tooltip="true" prop="weighingWeight" label="过磅净重（吨）" align="center" min-width="120">
                <template slot-scope="scope">
                  <div>
                    <span v-if="scope.row.weighingWeight == undefined || scope.row.weighingWeight == ''"></span>
                    <span v-else>{{ Number(scope.row.weighingWeight).toFixed(3) }}</span>
                  </div>
                </template>
              </el-table-column>
              <!-- <el-table-column :show-overflow-tooltip="true" prop="weighingDate" label="过磅净重时间" align="center" width="190"></el-table-column> -->
              <el-table-column :show-overflow-tooltip="true" prop="factoryWeight" label="出厂过磅净重" align="center" min-width="120">
                <template slot-scope="scope">
                  <div>
                    <span v-if="scope.row.factoryWeight == undefined || scope.row.factoryWeight == ''"></span>
                    <span v-else>{{ Number(scope.row.factoryWeight).toFixed(3) }}</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column :show-overflow-tooltip="true" prop="warehouseName" label="仓位" align="center"
                width="150"></el-table-column>
              <el-table-column :show-overflow-tooltip="true" prop="locationName" label="区位" align="center"></el-table-column>

              <!-- <el-table-column :show-overflow-tooltip="true" prop="locationName" label="区位" align="center" width="150"></el-table-column>
              <el-table-column :show-overflow-tooltip="true" prop="binName" label="货位" align="center" width="150"></el-table-column> -->
              <el-table-column :show-overflow-tooltip="true" prop="arrivalMethod" label="到货方式" align="center" min-width="100">
                <template scope="scope">
                  {{ scope.row.arrivalMethod == 1 ? '汽运' : scope.row.arrivalMethod == 2 ? '火运' : scope.row.arrivalMethod == 3 ?
                    '船运' : scope.row.arrivalMethod }}
                </template>

              </el-table-column>
              <el-table-column :show-overflow-tooltip="true" prop="driverName" label="司机" align="center"
              min-width="120"></el-table-column>
              <el-table-column :show-overflow-tooltip="true" prop="telephone" label="司机电话" align="center"
                width="150"></el-table-column>
              <el-table-column :show-overflow-tooltip="true" prop="idNumber" label="司机身份证号" align="center"
                width="180"></el-table-column>
              <el-table-column :show-overflow-tooltip="true" prop="sceneUser" label="现场人员" align="center"
              min-width="120"></el-table-column>
              <el-table-column :show-overflow-tooltip="true" prop="createUser" label="创建人" align="center"
                width="180"></el-table-column>
              <el-table-column :show-overflow-tooltip="true" prop="createTime" label="创建时间" align="center"
                width="200"></el-table-column>
              <el-table-column :show-overflow-tooltip="true" prop="ext1" label="备注" align="center"
                width="150"></el-table-column>
              <el-table-column :show-overflow-tooltip="true" prop="inExternalNo" label="入库外部单号" align="center" width="200">
              </el-table-column>
            </el-table>
          </div>
          <div class="pags">
            <el-pagination background @current-change="handleCurrentChangeT" :current-page="pageInfoT.pageNo"
              :page-size="pageInfoT.pageSize" :page-sizes="[10,20,30,40,50]"
              layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChangeT" :total="totalT">
            </el-pagination>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <!-- 进仓确认 -->
    <div>
      <el-dialog title="进仓确认" :visible.sync="dialogVisiblejincang" :close-on-click-modal="false"
        @close="dialogVisiblejincang=false" width="40%" center>
        <!--form表单-->
        <el-form :model="xiugaiFormData" ref="xiugaiFormData" label-width="100px" class="demo-dynamic"
          style="width:350px;margin:30px auto;">
          <el-form-item prop="inWarehouseNo" label="进仓单号" :rules="[
              { required: true, message: '请输入进仓单号', trigger: 'blur' },
            ]">
            <el-input size="mini" v-model="xiugaiFormData.inWarehouseNo" style="width:193px;"></el-input>
          </el-form-item>
        </el-form>
        <div style="width:150px;margin:15px auto;">
          <el-button @click="dialogVisiblejincang = false">取 消</el-button>
          <el-button type="primary" @click="jincangQR()" :loading="addLoad">确 定</el-button>
        </div>
      </el-dialog>
    </div>
    <!-- 修改进仓单号 -->
    <div>
      <el-dialog title="修改进仓单号" :visible.sync="XGDHvisible" :close-on-click-modal="false" @close="XGDHvisible=false"
        width="40%" center>
        <!--form表单-->
        <el-form :model="DHFormData" ref="DHFormData" label-width="150px" class="demo-dynamic"
          style="width:350px;margin:30px auto;">
          <el-form-item prop="modifyBefore" label="原进仓单号：">{{ oldDH }}</el-form-item>
          <el-form-item prop="modifyAfter" label="新进仓单号：" :rules="[
              { required: true, message: '请输入进仓单号', trigger: 'blur' },
            ]">
            <el-input size="mini" v-model.trim="DHFormData.modifyAfter" style="width:193px;"></el-input>
          </el-form-item>
        </el-form>
        <div style="width:300px;margin:15px auto;">
          <el-button @click="XGDHvisible = false">取 消</el-button>
          <el-button type="primary" @click="XGDH()" :loading="addLoad">确 定</el-button>
        </div>
      </el-dialog>
    </div>
    <!-- 修改记录 -->
    <div>
      <el-dialog title="修改记录" :visible.sync="XGJLVisible" :close-on-click-modal="false" width="50%" center=""
        @close='closeXGJL'>
        <el-table height="400px" border bordersize="mini" size="mini" ref="tabref" :data="XGRecordData"
          style="width:100%" highlight-current-row :header-cell-style="{background:'#F5F5F5',color:'black'}">
          <el-table-column prop="modifyBefore" label="修改前"></el-table-column>
          <el-table-column prop="modifyAfter" label="修改后"></el-table-column>
          <el-table-column prop="createUser" label="修改人"></el-table-column>
          <el-table-column prop="createTime" label="修改时间" :formatter="dateTimeFormat"></el-table-column>
        </el-table>
        <div style="width: 100px; margin: 15px auto">
          <el-button @click="closeXGJL" type="primary">关 闭</el-button>
        </div>
      </el-dialog>
    </div>
    <!--点击导入按钮弹出框-->
    <div class="addMarkBox" custom-class="el-dialog--center" v-if="daoruMark">
      <el-dialog @close="closeDialogFile" title="导入" :visible.sync="daoruMark" :close-on-click-modal="false" width="40%"
        center>
        <div style="margin: 15px auto" class="el-dialog--center">
          <input type="file" ref="file" accept=".xls, .csv, .xlsx" @change="getFile($event)" />
        </div>
        <div style="margin: 15px auto" class="el-dialog--center">
          <el-button @click="closeDialogFile">取消</el-button>
          <el-button type="primary" @click="daoruQueding()" :disabled="isDisable1">确定</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import {
  zidianKuwei, zidianQuwei,
  stockConfirmZy,
  waitEnteredZy,
  modifyStockConfirmZy,
  getStorkConfirmedlList,
  getWaitEnteredZyWeightNumber,
  revokeStockConfirmZy,
  alreadyEnteredZy,
  getAlreadyEnteredZyWeightNumber
} from '@/api/wms-access'
import {
  getRelationCustomer,
  getVirtualBalingList
} from '@/api/wms-stock'
import {
  getBtn
} from '@/utils/getButton'
import DonMessage from '@/utils/message'
import {
  dateTimeFormat
} from '@/utils/util'
import {
  exportExcel
} from '@/utils/fileDown.js'
export default {
  data () {
    return {
      DHFormData: {
        modifyAfter: '',
        modifyBefore: ''
      },
      CWData: [],
      QUData: [],
      productTypeData: [], // 货物类型
      steelMillNameData: [], // 产地
      specificationData: [], // 规格
      modelData: [], // 材质
      KHFormData: {
        modifyAfter: '',
        modifyBefore: ''
      },
      xiugaiFormData: {
        inWarehouseNo: ''
      },
      dateTimeFormat: dateTimeFormat, // 列表时间格式化
      activeName: 'first',
      pageInfo: {
        pageNo: 1,
        pageSize: 20
      },
      total: 0,
      totalT: 0,
      pageInfoT: {
        pageNo: 1,
        pageSize: 20
      },
      btnArr: [
        '003M4N0100',
        '003M4N0200',
        '003M4N0300',
        '003M4N0400',
        '003M4N0500',
        '003M4N0600',
        '003M4N0700',
        '003M4N0800',
        '003M4N0900'
      ],
      btnFlg: [],

      tableDataT: [],
      tableData: [],
      HZData: [],
      SHData: [{
        value: 1,
        label: '同意'
      },
      {
        value: 2,
        label: '驳回'
      }
      ],
      h: 500,
      H: 500,
      CBVisible: false,
      CBLoading: false,
      shFormData: {
        auditResult: '',
        auditRemark: ''
      },
      shRules: {
        auditResult: [{
          required: true,
          message: '请选择审核结果',
          trigger: 'change'
        }],
        auditRemark: [{
          required: false,
          message: '请输入驳回原因',
          trigger: 'change'
        }]
      },
      xuanzhongArr: [],
      shenheYijian: '',
      dialogShenheVisible: false,
      lookApproverReject: false,
      dialogVisiblejincang: false,
      addLoad: false,
      isDisable1: false,
      XGvisible: false,
      XGDHvisible: false,
      selectListId: [],
      selectList: [],
      subTableData: [],
      oldcustomer: '',
      oldDH: '',
      XGJLVisible: false,
      XGRecordData: [],
      importDialog: false,
      daoruMark: false,
      file: null,
      totalAllWeight: 0,
      totalNumber: 0,
      arrivalMethodData: [{
        value: '1',
        label: '火运'
      },
      {
        value: '2',
        label: '汽运'
      },
      {
        value: '3',
        label: '船运'
      }
      ],
      totalAllWeightB: 0,
      totalNumberB: 0,
      checked: false,
      jiesuanCustomer: '',
      // JSKHShow: false,
      feeCustomerDisplay: '1',
      width: '30%',
      oldPayCustomerName: '',
      oldUnitPrice: '',
      newPayCustomerName: '',
      newUnitPrice: '',
      feeNameOld: '',
      feeNameNew: '',
      customerData: []// 一级货主、二级货主
    }
  },
  computed: {
    JSKHShow: {
      get () {
        return this.feeCustomerDisplay != 1 && this.KHFormData.modifyAfter != ''
      },
      set (newValue) {
        if (newValue) this.width = '80%'
        else this.width = '30%'
      }
    }
  },
  watch: {
    checked: {
      immediate: true,
      handler (val) {
        if (!val) {
          this.width = '30%'
        } else {
          this.width = '80%'
        }
      }
    }
  },
  methods: {
    // 小星星
    Add (obj) {
      console.log(obj, this.subTableData)
      // if(obj.column.property == "unpackingNumber" || obj.column.property == "unpackingWeight" ){
      //   return 'star';
      // }、
      if (this.subTableData[0].inWeighingMethod == 1) {
        if (obj.column.property == 'unpackingNumber' || obj.column.property == 'unpackingWeight') {
          return 'star'
        }
      }
      if (this.subTableData[0].inWeighingMethod == 2) {
        if (obj.column.property == 'unpackingPoundWeight' || obj.column.property == 'unpackingNumber' || obj.column
          .property == 'unpackingWeight') {
          return 'star'
        }
      }
      if (this.subTableData[0].inWeighingMethod == 3) {
        console.log(11, 'method3')
        if (obj.column.property == 'unpackingFactoryPoundWeight' || obj.column.property == 'unpackingNumber' || obj
          .column.property == 'unpackingWeight') {
          console.log(21, 'method3')

          return 'star'
        }
      }
    },
    handleRow (row) {
      this.$refs.tableRef.toggleRowSelection(row)
    },
    handleRow1 (row) {
      this.$refs.QRTable.toggleRowSelection(row)
    },
    // 字典--库位
    zidianKuweiS () {
      zidianKuwei({
      })
        .then((res) => {
          this.CangweiOptions = res
          this.CWData = res
        })
        .catch((err) => {
          // console.log(err);
          this.$message({
            message: err.message,
            type: 'error'
          })
        })
    },
    changeCangWei (val) {
      this.$set(this.pageInfo, 'locationId', '')
      this.$set(this.pageInfoT, 'locationId', '')
      zidianQuwei({
        warehouseId: val
      })
        .then((res) => {
          this.QUData = res
        })
        .catch((err) => {
          // console.log(err);
          this.$message({
            message: err.message,
            type: 'error'
          })
        })
    },
    // 下拉框
    getVirtualBalingList () {
      getVirtualBalingList()
        .then(res => {
          this.steelMillNameData = []
          this.specificationData = []
          this.modelData = []
          this.productTypeData = []
          var obj = {}
          for (var i = 0; i < res.length; i++) {
            if (!obj[res[i].productTypeName]) {
              this.productTypeData.push(res[i])
              obj[res[i].productTypeName] = true
            }
          }
          // this.productTypeData = Array.from(new Set(res.map(item => item.productTypeName)))
          this.steelMillNameData = Array.from(new Set(res.map(item => item.placeOfOrigin)))
          this.specificationData = Array.from(new Set(res.map(item => item.specification)))
          this.modelData = Array.from(new Set(res.map(item => item.model)))
        })
        .catch(error => {
          DonMessage.error(error.message)
        })
    },
    // 货物类型下拉框改变事件
    productTypeChange (val) {
      this.goodsName = val
      getVirtualBalingList({
        productType: this.goodsName,
        placeOfOrigin: this.placeOfOrigin,
        specification: this.specificationVal,
        model: this.modelVal
      }).then(res => {
        this.steelMillNameData = []
        this.specificationData = []
        this.modelData = []
        this.productTypeData = []

        var obj = {}
        for (var i = 0; i < res.length; i++) {
          if (!obj[res[i].productTypeName]) {
            this.productTypeData.push(res[i])
            obj[res[i].productTypeName] = true
          }
        }
        this.steelMillNameData = Array.from(new Set(res.map(item => item.placeOfOrigin)))
        this.specificationData = Array.from(new Set(res.map(item => item.specification)))
        this.modelData = Array.from(new Set(res.map(item => item.model)))
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    // 产地下拉框改变事件
    steelMillNameChange (val) {
      this.placeOfOrigin = val

      getVirtualBalingList({
        productType: this.goodsName,
        placeOfOrigin: this.placeOfOrigin,
        specification: this.specificationVal,
        model: this.modelVal
      }).then(res => {
        this.steelMillNameData = []
        this.specificationData = []
        this.modelData = []
        this.productTypeData = []

        var obj = {}
        for (var i = 0; i < res.length; i++) {
          if (!obj[res[i].productTypeName]) {
            this.productTypeData.push(res[i])
            obj[res[i].productTypeName] = true
          }
        }
        this.steelMillNameData = Array.from(new Set(res.map(item => item.placeOfOrigin)))
        this.specificationData = Array.from(new Set(res.map(item => item.specification)))
        this.modelData = Array.from(new Set(res.map(item => item.model)))
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    // 规格下拉框改变事件
    specificationChange (val) {
      this.specificationVal = val
      getVirtualBalingList({
        productType: this.goodsName,
        placeOfOrigin: this.placeOfOrigin,
        specification: this.specificationVal,
        model: this.modelVal
      }).then(res => {
        this.steelMillNameData = []
        this.specificationData = []
        this.modelData = []
        this.productTypeData = []
        var obj = {}
        for (var i = 0; i < res.length; i++) {
          if (!obj[res[i].productTypeName]) {
            this.productTypeData.push(res[i])
            obj[res[i].productTypeName] = true
          }
        }
        this.steelMillNameData = Array.from(new Set(res.map(item => item.placeOfOrigin)))
        this.specificationData = Array.from(new Set(res.map(item => item.specification)))
        this.modelData = Array.from(new Set(res.map(item => item.model)))
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    // 材质下拉框改变事件
    modelChange (val) {
      this.modelVal = val
      getVirtualBalingList({
        productType: this.goodsName,
        placeOfOrigin: this.placeOfOrigin,
        specification: this.specificationVal,
        model: this.modelVal
      }).then(res => {
        this.lengthData = []
        this.steelMillNameData = []
        this.specificationData = []
        this.modelData = []
        this.productTypeData = []
        var obj = {}
        for (var i = 0; i < res.length; i++) {
          if (!obj[res[i].productTypeName]) {
            this.productTypeData.push(res[i])
            obj[res[i].productTypeName] = true
          }
        }
        this.steelMillNameData = Array.from(new Set(res.map(item => item.placeOfOrigin)))
        this.specificationData = Array.from(new Set(res.map(item => item.specification)))
        this.modelData = Array.from(new Set(res.map(item => item.model)))
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    // 待确认查询
    JfgetStockConfirmLists () {
      waitEnteredZy(this.pageInfo)
        .then(res => {
          console.log(res)
          this.tableData = res.list
          this.total = res.total
        })
        .catch(error => {
          DonMessage.error(error.message)
        })
    },
    selectGoods (selection) {
      this.selectListId = []
      this.selectList = selection
      let arry = []
      selection.forEach((item) => {
        arry.push(item.stockConfirmId) // id数组
        arry = Array.from(new Set(arry)) // 去重
      })
      console.log(arry)
      this.selectListId = arry.join(',') // 获取全部货物id
    },
    // 点击进仓按钮
    QRjincang () {
      if (this.xuanzhongArr.length == 0) {
        this.xuanzhongArr = this.tableData[0]
      }
      if (this.selectList.length == 0) {
        DonMessage.error('请选择一条数据进行进仓操作！')
      } else {
        this.dialogVisiblejincang = true
        this.addLoad = false
        this.xiugaiFormData.inWarehouseNo = ''
        this.$nextTick(() => {
          this.$refs.xiugaiFormData.clearValidate()
        })
      }
    },
    // 进仓保存
    jincangQR () {
      this.addLoad = true
      this.$refs.xiugaiFormData.validate((valid) => {
        if (valid) {
          stockConfirmZy({
            inWarehouseNo: this.xiugaiFormData.inWarehouseNo,
            stockConfirmIds: this.selectListId // 主表id
          })
            .then((res) => {
              DonMessage.success('操作成功!')
              this.addLoad = false
              this.chaxun()
            })
            .catch((err) => {
              DonMessage.error(err.message)
              this.addLoad = false
            })
          this.dialogVisiblejincang = false
        } else {
          this.addLoad = false
        }
      })
    },
    handleClicktab (tab, event) {
      if (this.activeName == 'first') {
        this.chongzhi()
      } else {
        this.chongzhiT()
      }
    },
    chaxun () {
      this.JfgetStockConfirmLists()
      this.getStockConfirmNumberJF()
    },
    chongzhi () {
      this.pageInfo = {
        pageNo: 1,
        pageSize: 20
      }
      this.JfgetStockConfirmLists()
      this.getVirtualBalingList()
      this.getStockConfirmNumberJF()
    },
    daochu () {
      let from = { ...this.pageInfo }
      delete from.pageNo
      delete from.pageSize
      exportExcel(
        this.global.wmsAccessName + '/instockThread/exportWaitEnteredZy', from,
        '待确认表'
      )
    },
    xiugai () {
      // if (this.selectList.length == 0) {
      //   this.selectList = this.tableData[0]
      // }

      if (this.selectList.length == 0) {
        DonMessage.error('请选择一条数据进行修改操作！')
      } else if (this.selectList.length > 1) {
        DonMessage.error('请选择一条数据进行修改操作！')
      } else {
        // getFeeCustomerDisplay(
        //   {
        //     stockConfirmId: this.selectList[0].stockConfirmId,
        //     modifyAfter: this.selectList[0].customerName,
        //     modifyAfterId: this.selectList[0].customerTaxId
        //   }
        // ).then(res => {
        //   console.log(res)
        //   this.feeCustomerDisplay = res
        // })
        //   .catch(error => {
        //     this.message.error(error.message)
        //   })
        this.checked = false
        this.JSKHShow = false
        this.feeCustomerDisplay = '1'
        this.XGvisible = true
        this.oldcustomer = this.selectList[0].customerName
        this.KHFormData.modifyAfter = ''
        this.$nextTick(() => {
          this.$refs.KHFormData.clearValidate()
        })
        this.jiesuanCustomer = ''
      }
    },
    // 已确认查询
    JfgetStockConfirmedLists () {
      alreadyEnteredZy(this.pageInfoT)
        .then(res => {
          console.log(res)
          this.tableDataT = res.list
          this.totalT = res.total
        })
        .catch(error => {
          DonMessage.error(error.message)
        })
    },
    chaxunT () {
      this.JfgetStockConfirmedLists()
      this.getStockConfirmNumberJF()
    },
    chongzhiT () {
      this.pageInfoT = {
        pageNo: 1,
        pageSize: 20
      }
      this.JfgetStockConfirmedLists()
      this.getVirtualBalingList()
      this.zidianKuweiS()
      this.getStockConfirmNumberJF()
    },
    daochuT () {
      let from = { ...this.pageInfoT }
      delete from.pageNo
      delete from.pageSize
      exportExcel(
        this.global.wmsAccessName + '/instockThread/exportAlreadyEnteredZy', from,
        '已确认表'
      )
    },
    xiugaiT () {
      if (this.selectList.length == 0) {
        DonMessage.error('请选择一条数据进行修改操作！')
      } else if (this.selectList.length > 1) {
        DonMessage.error('请选择一条数据进行修改操作！')
      } else {
        this.XGDHvisible = true
        this.oldDH = this.selectList[0].inWarehouseNo
        this.$nextTick(() => {
          this.$refs.DHFormData.clearValidate()
        })
        this.DHFormData.modifyAfter = ''
      }
    },
    chexiao () {
      if (this.selectList.length == 0) {
        DonMessage.error('请选择一条数据进行修改操作！')
      } else {
        this.$confirm('是否执行撤销操作?', '系统提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消'
        }).then(() => {
          const loading = this.$loading({
            lock: true,
            text: '正在处理...'
          })
          revokeStockConfirmZy({
            stockConfirmIds: this.selectList.map(item => item.stockConfirmId).join(',')
          }).then(res => {
            loading.close()
            this.$message({
              message: '成功',
              type: 'success'
            })
            this.chaxunT()
          }).catch(error => {
            this.$message({
              showClose: true,
              message: error.message,
              type: 'error',
              onClose () {
                loading.close()
              }
            })
          })
        }).catch(() => {

        })
      }
    },

    // 修改单号
    XGDH () {
      this.addLoad = true
      this.$refs.DHFormData.validate((valid) => {
        if (valid) {
          modifyStockConfirmZy({
            stockConfirmIds: this.selectList[0].stockConfirmId,
            businessType: 2,
            modifyAfter: this.DHFormData.modifyAfter,
            modifyBefore: this.selectList[0].inWarehouseNo

          })
            .then((res) => {
              DonMessage.success('操作成功!')
              this.addLoad = false
              this.JfgetStockConfirmedLists()
            })
            .catch((err) => {
              DonMessage.error(err.message)
              this.addLoad = false
            })
          this.XGDHvisible = false
        } else {
          this.addLoad = false
        }
      })
    },
    NumberInput (row) {
      console.log(row)
      this.$set(row, 'unpackingWeight', parseFloat((row.unpackingNumber / 1 * row.singletonWeight / 1).toFixed(6)))
    },
    // 修改记录
    editRecord (index, row) {
      this.XGJLVisible = true
      // console.log(22)
      getStorkConfirmedlList({
        businessId: row.stockConfirmId,
        businessType: 2
      })
        .then(res => {
          console.log(res)
          this.XGRecordData = res
        })
        .catch(err => {
          this.$message({
            message: err.message,
            type: 'error'
          })
        })
    },
    // 修改记录关闭
    closeXGJL () {
      this.XGJLVisible = false
    },
    handleCurrentChange (val) {
      this.pageInfo.pageNo = val
      this.JfgetStockConfirmLists()
    },
    handleSizeChange (val) {
      this.pageInfo.pageSize = val
      this.JfgetStockConfirmLists()
    },
    handleCurrentChangeT (val) {
      this.pageInfoT.pageNo = val
      this.JfgetStockConfirmedLists()
    },
    handleSizeChangeT (val) {
      this.pageInfoT.pageSize = val
      this.JfgetStockConfirmedLists()
    },

    // 总吨数、总件数
    getStockConfirmNumberJF () {
      if (this.activeName == 'first') {
        getWaitEnteredZyWeightNumber(this.pageInfo).then(res => {
          console.log(res)
          this.totalAllWeight = res.totalAllWeight
          this.totalNumber = res.totalNumber
        }).catch(error => {
          DonMessage.error(error.message)
        })
      } else {
        getAlreadyEnteredZyWeightNumber(this.pageInfoT).then(res => {
          console.log(res)
          this.totalAllWeightB = res.totalAllWeight
          this.totalNumberB = res.totalNumber
        }).catch(error => {
          DonMessage.error(error.message)
        })
      }
    }

  },
  created () {
    this.btnFlg = getBtn(this.btnArr, '/jincangQueren')
    getRelationCustomer().then(res => {
      this.customerData = res // 客户
    }).catch(err => {
      this.$message.error(err.message)
    })
    this.zidianKuweiS()
    this.getVirtualBalingList()
    this.JfgetStockConfirmLists()
    this.JfgetStockConfirmedLists()
    this.getStockConfirmNumberJF()
    var _this = this
    document.onkeydown = function (e) {
      let key = window.event.keyCode
      if (key == 13) {
        if (_this.CBVisible == true) {
          // 拆包
          _this.succeCB()
        } else if (_this.XGvisible == true) {
          // 修改客户
          _this.XGQD()
        } else if (_this.dialogVisiblejincang == true) {
          // 进仓确认
          _this.jincangQR()
        } else if (_this.daoruMark == true) {
          // 导入
          _this.daoruQueding()
        } else if (_this.activeName == 'first') {
          _this.chaxun()
        } else if (_this.activeName == 'second') {
          _this.chaxunT()
        }
      }
    }
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = pH - h - 205 + 'px'
    let H = this.$refs.searchBoxT.offsetHeight
    let pHT = document.documentElement.clientHeight
    this.H = pHT - H - 350 + 'px'
  }
}

</script>

<style lang="less" scoped>
  .inpBox {
    .el-form-item {
      margin-left: 10px;
      margin-bottom: 0px;
    }
  }

  /deep/.el-table th.star div::before {
    content: '*' !important;
    color: red !important;
  }
  .formBox /deep/ .el-form-item{
  margin-bottom: -6px!important;
}
.detailsTitle{
  margin-bottom: 0;
}
    /deep/.el-tabs__header{
  margin-bottom: 0;
}
</style>
